'use client';

import React from 'react';
import { Box, List, ListItem } from '@mui/material';
import Link from 'next/link';
import CustomImage from '@components/CustomImage';
import SmoothScrollLink from '@components/SmoothScrollLink';

import cn from './style.module.scss';

type NavItem = {
  id: number;
  label: string;
  url: string;
  isButton?: boolean;
};

type WharfDesktopProps = {
  navData: {
    left?: NavItem[];
    right?: NavItem[];
    logo: {
      src: string;
      alt: string;
      url: string;
    };
  };
};

export default function WharfDesktop({ navData }: WharfDesktopProps) {
  const { left = [], right = [], logo } = navData || {};
  return (
    <Box className={cn.wharfDesktopWrapper}>
      <Box className={cn.wharfMenuLeft}>
        <List className={cn.headerNavigationList}>
          {left.map((item) => (
            <ListItem key={item.id}>
              <SmoothScrollLink
                className={cn.bermondseyNavigationLink}
                href={item.url}
              >
                {item.label}
              </SmoothScrollLink>
            </ListItem>
          ))}
        </List>
      </Box>
      <Box className={cn.desktopLogoBlock}>
        <Box className={cn.wharfDesktopLogo}>
          <Link href={logo.url}>
            <CustomImage
              src={logo.src}
              alt={logo.alt}
              width={120}
              height={40}
            />
          </Link>
        </Box>
      </Box>
      <Box className={cn.wharfMenuRight}>
        <List className={cn.headerNavigationList}>
          {right.map((item) => (
            <ListItem key={item.id}>
              <SmoothScrollLink
                href={item.url}
                className={item.isButton ? cn.enquireBtn : ''}
              >
                {item.label}
              </SmoothScrollLink>
            </ListItem>
          ))}
        </List>
      </Box>
    </Box>
  );
}
